const INIT_STATE = {
   formInfo: {},
   sqlValues: {},
   gridSqlValues: {},
   listTableResponses: {},
   gridFormRefs: [],
   backUrl: "",
   comments: [],
   messageHistory: [],
   listTablePromises: {},
};

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_FORM_INFO": {
         return { ...state, formInfo: { ...state.formInfo, ...action.payload } };
      }
      case "SET_SQL_VALUES": {
         return { ...state, sqlValues: { ...state.sqlValues, ...action.payload } };
      }
      case "SET_GRID_SQL_VALUES": {
         return { ...state, gridSqlValues: { ...state.gridSqlValues, ...action.payload } };
      }
      case "SET_LIST_TABLE_RESPONSES": {
         return {
            ...state,
            listTableResponses: {
               ...state.listTableResponses,
               ...action.payload,
            },
         };
      }
      case "RESET_ALL_SQL_VALUES": {
         return { ...state, gridSqlValues: {}, sqlValues: {}, listTableResponses: {} };
      }
      case "SET_MAIL_TITLE": {
         return { ...state, mailTitle: action.payload };
      }
      case "SET_GRID_FORM_REFS": {
         return { ...state, gridFormRefs: action.payload };
      }
      case "ADD_GRID_FORM_REF": {
         return {
            ...state,
            gridFormRefs: [
               ...state.gridFormRefs,
               { id: action.payload.mainRecordId, ref: action.payload.gridFormRef },
            ],
         };
      }
      case "REMOVE_GRID_FORM_REF": {
         return {
            ...state,
            gridFormRefs: state.gridFormRefs.filter((data) => data.id !== action.payload),
         };
      }
      case "SET_GRID_REQUEST_FIELD_ID": {
         // Grid request field id is a num1_updated parameter from the table field.
         // It is needed to save form correctly
         return { ...state, formInfo: { ...state.formInfo, gridRequestFieldId: action.payload } };
      }
      case "SET_BACK_URL": {
         return { ...state, backUrl: action.payload };
      }
      case "SET_COMMENTS": {
         return { ...state, comments: action.payload };
      }
      case "CLEAR_COMMENTS": {
         return { ...state, comments: [] };
      }
      case "SET_MESSAGE_HISTORY": {
         return { ...state, messageHistory: action.payload };
      }
      case "CLEAR_MESSAGE_HISTORY": {
         return { ...state, messageHistory: [] };
      }
      case "DELETE_FORM_INFO": {
         const newFormInfo = { ...state.formInfo };
         delete newFormInfo[action.payload];
         return { ...state, formInfo: { ...newFormInfo } };
      }
      case "CLEAR_FORM_INFO": {
         return { ...state, formInfo: {} };
      }
      case "SET_ANSWER": {
         return {
            ...state,
            formInfo: {
               ...state.formInfo,
               [action.payload.formUuid]: {
                  ...state.formInfo[action.payload.formUuid],
                  questionnaireTableAnswers: {
                     ...state.formInfo[action.payload.formUuid].questionnaireTableAnswers,
                     [action.payload.data.question_id]: action.payload.data,
                  },
               },
            },
         };
      }
      case "SET_LIST_TABLE_PROMISE": {
         return {
            ...state,
            listTablePromises: {
               ...state.listTablePromises,
               [action.payload.techName]: action.payload.promise,
            },
         };
      }
      case "RESOLVE_LIST_TABLE_PROMISE": {
         const promises = { ...state.listTablePromises };
         if (promises[action.payload]) {
            promises[action.payload].resolve();
            delete promises[action.payload];
         }
         return {
            ...state,
            listTablePromises: promises,
         };
      }
      case "CLEAR_LIST_TABLE_PROMISES": {
         return {
            ...state,
            listTablePromises: {},
         };
      }
      default:
         return state;
   }
};
